exports = module.exports = require("../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n  box-sizing: border-box; }\n\nhtml {\n  font-size: 62.5%; }\n  html body {\n    margin: 0;\n    padding: 0;\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n    width: 100vw;\n    height: 100vh; }\n", ""]);

// exports
